import { IOffer, IPhotoFeatureIcon } from '../../../types';
import { pathOr } from 'ramda';

export function preparePhotoFeatureIcons(offer: IOffer): IPhotoFeatureIcon[] | null {
  return pathOr(null, ['photoFeatureIcons'], offer);
}
